import { useRef } from 'react';
import { Button } from '../atoms/Button';
import { LucideImage } from 'lucide-react';
import SelectImageInput, {
  SelectImageInputRef,
} from '../atoms/SelectImageInput';
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  Path,
  UseFormRegister,
} from 'react-hook-form';

interface AddImageProps<T extends Record<string, unknown>> {
  allowSelectMultiple?: boolean;
  name: Path<T>;
  register?: UseFormRegister<T>;
  error?: Merge<
    FieldError,
    (
      | Merge<
          FieldError,
          FieldErrorsImpl<{
            name: NonNullable<string>;
            size: NonNullable<number>;
            type: NonNullable<string>;
            data: NonNullable<string>;
          }>
        >
      | undefined
    )[]
  >;
  onSelectedImages?: (images: File[]) => void;
}

export function AddImage<T extends Record<string, unknown>>({
  allowSelectMultiple = false,
  onSelectedImages,
  register,
  name,
  error,
}: AddImageProps<T>) {
  const fileInputRef = useRef<SelectImageInputRef>(null);
  return (
    <div className="flex-1">
      <Button
        type="button"
        variant="secondary"
        fullWidth
        prefixIcon={<LucideImage />}
        onClick={(_) =>
          fileInputRef.current && fileInputRef.current.onClickBtn()
        }
      >
        ADD {allowSelectMultiple ? 'IMAGES' : 'IMAGE'}
        <SelectImageInput
          name={name}
          register={register}
          ref={fileInputRef}
          error={error}
          allowSelectMultiple={allowSelectMultiple}
          onSelectedImages={onSelectedImages}
          hidden
        />
      </Button>
      {error?.message && (
        <div className="mt-2 text-red-500">{error.message}</div>
      )}
    </div>
  );
}
